import type { V2PrivateOperation } from "../../redacted/v2/session";

/**
 * The private action listed among the header's pending transactions. An
 * action undone before sending is not listed: nothing was sent, so there is
 * nothing to follow up on.
 */
export const privateHeaderOperation = (
  enabled: boolean,
  operation?: V2PrivateOperation
) =>
  enabled && operation && !operation.cancelled
    ? { ...operation, network: "THOR" as const }
    : undefined;
